import { store } from "../../../store/store";
import { Categories } from "../../constants/econsult/Category";
import { CacheDataToRefresh } from "../subject-behaviour/CommonRxjsService";
import { getImagePath, checkOSPlatform } from "../CommonUtils";
import RefreshCacheAction from "../webapp-services/RefreshCache";

export const refreshEConsult = () => {
    let refreshList = [{
        name: RefreshCacheAction.refreshOrderAndEconsultData,
        requestData: { fetchConsultations: true }
    }]
    CacheDataToRefresh.setRefreshList(refreshList)
}
export function setConsultationAnswer(qData, ansList, ansData) {
    ansList[qData['qid']] = ansData;
    return ansList;
}

export function getConsultationAnswer(qData, ansList) {
    return ansList[qData['qid']];
}

export function getConsultationAnsValue(qData, ansData) {
    const reduxState = store.getState();
    const ansList = reduxState.consultationAnswer;
    if (qData['qid'] && ansData && ansData[qData['qid']])
        return ansData[qData['qid']][qData['rskey']];
    else if (ansList[qData['qid']] && ansList[qData['qid']][qData['qid']])
        return ansList[qData['qid']][qData['qid']][qData['rskey']];
    else return;
}

export function getConsultationAnsTextInputValue(qData, ansData) {
    if (ansData[qData['qid']])
        return ansData[qData['qid']]['textInput']
        [ansData[qData['qid']][qData['rskey']]];
    else return;
}

export function checkSubsIDExist(parentId, questionId) {
    return questionId.startsWith(parentId) && questionId != parentId;
}

export function checkConsultationType(consultType) {
    switch (consultType) {
        case 'Remote Consultation': return 'E-Consult';
        case 'Followup': return 'Follow up';
        case 'FollowUp': return 'Follow up';
        default: return 'E-Consult';
    }
}

export function checkCaseCodeLength(category: String) {
    if (category) {
        var splitArr = category.split(' ');
        var stringLength = 0;
        var returnString = ''
        splitArr.forEach((subPart) => {
            if (stringLength + subPart.length > 16) {
                returnString = returnString + '\n' + subPart;
                stringLength = 0;
            } else {
                returnString = returnString + ' ' + subPart;
                stringLength = stringLength + subPart.length;
            }
        })
        return returnString;
    } return '';

}

export function getCategoryImageNetworkURL(caseCode) {
    var imageURL = getImagePath('/images/RoundMiscellaneous.webp');
    for (const [, category] of Object.entries(Categories)) {
        if (caseCode == category.caseCode) {
            imageURL = checkOSPlatform(category);
            break;
        }
    }
    return imageURL;
}

export const getConsultFromID = (consultList: any[], consultId) => {
    var consultData = consultList[0];
    consultList.forEach((consult: any) => {
        if (consult['id'] == consultId)
            consultData = consult;
    })
    return consultData;
}